var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1_1",
    transform: "translate(-614.000000, -566.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(485.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(119.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-outline",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#000000",
    opacity: 0,
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51,20 L8.43,20 C6.81835996,19.9858889 5.23002505,19.6135695 3.78,18.91 C3.23250412,18.6528223 2.91630614,18.0690722 3,17.47 C3.09096132,16.86728 3.55892281,16.3912502 4.16,16.29 C5.05861049,16.1701107 5.92308631,15.8672038 6.7,15.4 C3.95200735,13.2515051 2.6041765,9.76864871 3.19,6.33 C3.26962008,5.78402923 3.66037447,5.33466169 4.19,5.18 C4.7057624,5.01802186 5.26841966,5.17934317 5.62,5.59 C6.80025381,7.13762852 8.56482742,8.13200914 10.5,8.34 C10.5457393,7.16185291 11.0520369,6.04871624 11.91,5.24 C12.7753748,4.41134123 13.9371932,3.96478026 15.1348045,4.00050179 C16.3324158,4.03622332 17.465553,4.55123665 18.28,5.43 C18.4949406,5.62002575 18.8040742,5.65965826 19.06,5.53 C19.5467119,5.30044919 20.1221936,5.37245358 20.5373439,5.71484555 C20.9524941,6.05723753 21.1327163,6.60849412 21,7.13 C20.76935,8.08011458 20.3323387,8.96779368 19.72,9.73 C19.4390592,15.6515481 14.4334528,20.2374158 8.51,20 Z M8.51,18 L8.59,18 C10.9384776,18.0807774 13.2215221,17.2178561 14.9294369,15.6038861 C16.6373517,13.989916 17.627922,11.7592893 17.68,9.41 C17.6965123,9.09125192 17.827958,8.78928222 18.05,8.56 C18.293905,8.25124639 18.501908,7.9157577 18.67,7.56 C17.9413817,7.56138642 17.2466938,7.25223215 16.76,6.71 C16.2925433,6.24649558 15.6582278,5.99060692 15,6 C14.3353171,5.98281255 13.6911691,6.23111544 13.21,6.69 C12.555877,7.31071045 12.2815767,8.23266421 12.49,9.11 L12.75,10.25 L11.58,10.33 C9.15351967,10.5278636 6.76251863,9.65043203 5.04,7.93 C4.96556624,10.6144506 6.40788658,13.1124102 8.77,14.39 L9.72,14.93 L9.09,15.83 C8.40869205,16.7235231 7.47518455,17.3923046 6.41,17.75 C7.09331253,17.9212662 7.7955709,18.0052009 8.5,18 L8.51,18 Z",
    id: "Shape",
    fill: "#1D2B7D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTwitter);
export default __webpack_public_path__ + "static/media/Share-twitter.165f213b7c332fa51173cad6f536faba.svg";
export { ForwardRef as ReactComponent };